import clothing from './clothing';
import footwear from './footwear';

const headermenu = [
  {
    children: footwear,
    name: 'Footwear',
    path: '/release-dates/'
  },
  {
    name: 'Marketplace',
    path: '/sole-market/',
    slug: 'sole-market'
  },
  {
    children: clothing,
    name: 'Clothing',
    path: '/clothing/'
  },
  {
    name: 'Sale',
    path: '/release-dates/?sort=SALE',
    slug: 'sale'
  },
  {
    name: 'News',
    path: '/news/',
    slug: 'news'
  }
];

export default headermenu;
